module.exports = __webpack_public_path__ + "img/tb1041-3-1974.prt.ff2cb86a.jpg";